// extracted by mini-css-extract-plugin
export var section = "index-module--section--a576e";
export var sectionAlways = "index-module--sectionAlways--bf41c";
export var sectionDesc = "index-module--sectionDesc--6b82f";
export var sectionEven = "index-module--sectionEven--53382";
export var sectionHeader = "index-module--sectionHeader--66fb8";
export var sectionOdd = "index-module--sectionOdd--d199e";
export var sectionTitle = "index-module--sectionTitle--657b5";